import React from 'react';
import LiveEditField from 'components/forms/LiveEditField';
import { EditableStatusType } from 'types/FieldTypes';

interface ProductDescriptionTabProps {
    viewKey: string;
    itemId: string;
    data: any;
    isEditable?: EditableStatusType;
    refetchData?: () => void;
};

const ProductDescriptionTab: React.FC<ProductDescriptionTabProps> = ({ viewKey, itemId, data, isEditable, refetchData }) => {
    return (
        <div className='card product-description-tab'>
            <LiveEditField 
                viewKey={viewKey}
                apiObject='product'
                fieldItem={{
                    type: 'textarea',
                    name: 'description',
                    label: 'product.general.extended_description_label',
                    placeholder: 'product.general.description_placeholder',
                    enableStyling: 'simple',
                    showToolbarInitially: true,
                    rows: 10
                }}
                itemId={itemId}
                data={data} 
                alignment='stacked'
                isEditable={isEditable}
                refetchData={() => {if (refetchData) refetchData()}}
            />
        </div>
    )
}

export default ProductDescriptionTab;